import React from "react";
import Select from "react-dropdown-select";
import { useLocation } from "@reach/router";
import { navigate } from "gatsby";
import { areasArray } from "../../locations";
import { useI18nL10nContext} from "gatsby-plugin-i18n-l10n";

import { Global } from "@emotion/react";
import {emotionGlobalCss} from "./styles";

export default function CitySwitcher() {
  const languageContext = useI18nL10nContext();
  const location = useLocation();
  const initialValue:any = areasArray.filter((area: any) => location.href?.includes(area.link));
  //const [value, setValue] = useState(initialValue);

  //console.log("languageContext: ",languageContext);
  // console.log("location: ",location);
  
  const handleOnchange = (values: any) => {
    const city:string = areasArray.filter((area)=>area.link?.includes(values[0].link))[0].link;
    const language:string =  location.href?.includes(`${city}/en`)?"/en":"/fr";
    const newPath:string | undefined = languageContext.translations?.filter((path)=>path.path?.includes(city) && path.path?.includes(language) )[0]?.path;
    //console.log("newPath: ",newPath);
    //console.log("language: ",language);
    navigate(newPath || "/");
  }
  return (
    <>
    <Global styles={emotionGlobalCss} />
      {areasArray.some((area: any) => location.href?.includes(area.link))?
        <Select
          options={areasArray}
          values={initialValue}
          onChange={handleOnchange}
          searchable={false}
          labelField="city"
          valueField="link"
        />
        :
        <></>
      }
    </>

  )
};